import { axios } from '@/utils/request'

export function applyList(params) {
  return axios({
    url: '/adult/admin/info',
    params: params,
    method: 'GET'
  })
}

export function getStationApplyUserInfo(params) {
  return axios({
    url: '/adult/admin/station/info',
    params: params,
    method: 'GET'
  })
}

export function deleteApply(id) {
  return axios({
    url: '/adult/admin/delete/' + id,
    method: 'GET'
  })
}

export function stateDeleteApply(id) {
  return axios({
    url: '/adult/delete/' + id,
    method: 'GET'
  })
}

export function exportExcel() {
  return axios({
    url: '/adult/admin/export',
    method: 'GET'
  })
}

export function adminUploadFunc(params) {
  return axios({
    url: '/adult/admin/adminImportExcel',
    method: 'POST',
    data: params
  })
}

export function uploadFunc(params) {
  return axios({
    url: '/adult/admin/importExcel',
    method: 'POST',
    data: params
  })
}

export function changeTime(params) {
  return axios({
    url: '/adult/admin/limit',
    data: params,
    method: 'POST'
  })
}

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url, parameter) {
  return axios({
    url: url,
    params: parameter,
    method: 'get',
    responseType: 'blob'
  })
}